import script from "./AutosizeTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./AutosizeTextArea.vue?vue&type=script&setup=true&lang=js"

import "./AutosizeTextArea.vue?vue&type=style&index=0&id=7625177b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7625177b"]])

export default __exports__